module.exports = __webpack_public_path__ + "portal-static/img/课程.实验成绩.4110b7d7.png";